/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Care Club API - ASP.NET 8 - DEVELOPMENT (Local)
 * The Care Club API is a comprehensive backend service developed using ASP.NET 8. It facilitates seamless data access and interaction for services requiring information from the Care Club system. This API is designed to provide secure, reliable, and efficient access to member and service data, ensuring that all dependent applications can operate smoothly.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CCNewAPIDtoAddressDto,
  CCNewAPIDtoAgreementAddressesDto,
  CCNewAPIDtoAgreementResponseDto,
  CCNewAPIDtoCreateAgreementDto,
  CCNewAPIDtoCustomerDto,
  CCNewAPIDtoFeeWithAdjustmentDto,
  CCNewAPIDtoPaymentDetailsDto,
  CCNewAPIDtoServiceAgreementOfferDto,
  CCNewAPIModelsServiceAgreementInvoice,
  CCNewAPIModelsServiceAgreementOffer,
  CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto,
  CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedResponseDto,
  CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto,
  CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto,
  CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto,
  CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto,
  CareClubCCMAPIModelsDtoGeneratedInvoiceDto,
  CareClubCCMAPIModelsDtoInvoiceRequestDto,
  CareClubCCMAPIModelsStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsResult,
  CareClubCCMAPIModelsViewModelsPlanCostAfterOffersView,
  GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodParams,
  MicrosoftAspNetCoreMvcIActionResult,
  MicrosoftAspNetCoreMvcProblemDetails,
  PostApiCustomersCreateOrUpdateParams,
  PostApiCustomersSendWelcomePackParams,
  PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams,
  PostApiOffersGetAvailableOffersWithDiscountsParams,
  RightioEmailSenderModelsEmailNoAttachmentsDto
} from '../../model';

import { customInstance } from '../../../../../services/CCMAccess/index';
import type { ErrorType , BodyType } from '../../../../../services/CCMAccess/index';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postApiCostServiceInvoicingGenerateInvoices = (
    careClubCCMAPIModelsDtoInvoiceRequestDto: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>(
      {url: `/api/CostServiceInvoicing/GenerateInvoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoInvoiceRequestDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingGenerateInvoicesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingGenerateInvoices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateInvoices>>, {data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingGenerateInvoices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingGenerateInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateInvoices>>>
    export type PostApiCostServiceInvoicingGenerateInvoicesMutationBody = BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>
    export type PostApiCostServiceInvoicingGenerateInvoicesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingGenerateInvoices = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateInvoices>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingGenerateInvoicesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiCostServiceInvoicingGenerateDiscountedInvoices = (
    careClubCCMAPIModelsDtoInvoiceRequestDto: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>(
      {url: `/api/CostServiceInvoicing/GenerateDiscountedInvoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoInvoiceRequestDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingGenerateDiscountedInvoicesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateDiscountedInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateDiscountedInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingGenerateDiscountedInvoices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateDiscountedInvoices>>, {data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingGenerateDiscountedInvoices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingGenerateDiscountedInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateDiscountedInvoices>>>
    export type PostApiCostServiceInvoicingGenerateDiscountedInvoicesMutationBody = BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>
    export type PostApiCostServiceInvoicingGenerateDiscountedInvoicesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingGenerateDiscountedInvoices = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateDiscountedInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingGenerateDiscountedInvoices>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingGenerateDiscountedInvoicesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiCostServiceInvoicingApplyDiscountsToExistingInvoices = (
    careClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>(
      {url: `/api/CostServiceInvoicing/ApplyDiscountsToExistingInvoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingApplyDiscountsToExistingInvoicesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyDiscountsToExistingInvoices>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyDiscountsToExistingInvoices>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingApplyDiscountsToExistingInvoices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyDiscountsToExistingInvoices>>, {data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingApplyDiscountsToExistingInvoices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingApplyDiscountsToExistingInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyDiscountsToExistingInvoices>>>
    export type PostApiCostServiceInvoicingApplyDiscountsToExistingInvoicesMutationBody = BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>
    export type PostApiCostServiceInvoicingApplyDiscountsToExistingInvoicesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingApplyDiscountsToExistingInvoices = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyDiscountsToExistingInvoices>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyDiscountsToExistingInvoices>>,
        TError,
        {data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerInvoiceApplyDiscountsRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingApplyDiscountsToExistingInvoicesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiCostServiceInvoicingRenumberInvoices = (
    careClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>(
      {url: `/api/CostServiceInvoicing/RenumberInvoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingRenumberInvoicesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingRenumberInvoices>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingRenumberInvoices>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingRenumberInvoices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingRenumberInvoices>>, {data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingRenumberInvoices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingRenumberInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingRenumberInvoices>>>
    export type PostApiCostServiceInvoicingRenumberInvoicesMutationBody = BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>
    export type PostApiCostServiceInvoicingRenumberInvoicesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingRenumberInvoices = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingRenumberInvoices>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingRenumberInvoices>>,
        TError,
        {data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerRenumberInvoicesRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingRenumberInvoicesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiCostServiceInvoicingShiftInvoiceDates = (
    careClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>(
      {url: `/api/CostServiceInvoicing/ShiftInvoiceDates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingShiftInvoiceDatesMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingShiftInvoiceDates>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingShiftInvoiceDates>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingShiftInvoiceDates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingShiftInvoiceDates>>, {data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingShiftInvoiceDates(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingShiftInvoiceDatesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingShiftInvoiceDates>>>
    export type PostApiCostServiceInvoicingShiftInvoiceDatesMutationBody = BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>
    export type PostApiCostServiceInvoicingShiftInvoiceDatesMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingShiftInvoiceDates = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingShiftInvoiceDates>>, TError,{data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingShiftInvoiceDates>>,
        TError,
        {data: BodyType<CareClubCCMAPIControllersCostServiceInvoicingControllerShiftInvoiceDatesRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingShiftInvoiceDatesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiCostServiceInvoicingApplyInvoiceRounding = (
    careClubCCMAPIModelsDtoGeneratedInvoiceDto: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/CostServiceInvoicing/ApplyInvoiceRounding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoGeneratedInvoiceDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingApplyInvoiceRoundingMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyInvoiceRounding>>, TError,{data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyInvoiceRounding>>, TError,{data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingApplyInvoiceRounding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyInvoiceRounding>>, {data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingApplyInvoiceRounding(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingApplyInvoiceRoundingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyInvoiceRounding>>>
    export type PostApiCostServiceInvoicingApplyInvoiceRoundingMutationBody = BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>
    export type PostApiCostServiceInvoicingApplyInvoiceRoundingMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingApplyInvoiceRounding = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyInvoiceRounding>>, TError,{data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingApplyInvoiceRounding>>,
        TError,
        {data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingApplyInvoiceRoundingMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiCostServiceInvoicingConvertToCsv = (
    careClubCCMAPIModelsDtoGeneratedInvoiceDto: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CostServiceInvoicing/ConvertToCsv`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoGeneratedInvoiceDto, signal
    },
      options);
    }
  


export const getPostApiCostServiceInvoicingConvertToCsvMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingConvertToCsv>>, TError,{data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingConvertToCsv>>, TError,{data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}, TContext> => {

const mutationKey = ['postApiCostServiceInvoicingConvertToCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCostServiceInvoicingConvertToCsv>>, {data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCostServiceInvoicingConvertToCsv(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCostServiceInvoicingConvertToCsvMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCostServiceInvoicingConvertToCsv>>>
    export type PostApiCostServiceInvoicingConvertToCsvMutationBody = BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>
    export type PostApiCostServiceInvoicingConvertToCsvMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostApiCostServiceInvoicingConvertToCsv = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCostServiceInvoicingConvertToCsv>>, TError,{data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCostServiceInvoicingConvertToCsv>>,
        TError,
        {data: BodyType<NonReadonly<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>>},
        TContext
      > => {

      const mutationOptions = getPostApiCostServiceInvoicingConvertToCsvMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will either create a new service agreement address record or update an existing one based on the provided address details.
The user ID and application ID are provided via HTTP headers.
The operation is performed asynchronously.
            
Headers:
    UserId: 123
    ApplicationId: 456
            
Sample request:
            
    POST /CreateOrUpdateServiceAgreementAddress
    {
       "addressDto": {
           "Street": "123 Main St",
           "Town": "London",
           "County": "Greater London",
           "Postcode": "SW1A 1AA",
       }
    }
 * @summary Creates or updates a service agreement address.
 */
export const postApiAddressesCreateOrUpdate = (
    cCNewAPIDtoAddressDto: BodyType<CCNewAPIDtoAddressDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoAddressDto>(
      {url: `/api/Addresses/CreateOrUpdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoAddressDto, signal
    },
      options);
    }
  


export const getPostApiAddressesCreateOrUpdateMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdate>>, TError,{data: BodyType<CCNewAPIDtoAddressDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdate>>, TError,{data: BodyType<CCNewAPIDtoAddressDto>}, TContext> => {

const mutationKey = ['postApiAddressesCreateOrUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdate>>, {data: BodyType<CCNewAPIDtoAddressDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAddressesCreateOrUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAddressesCreateOrUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdate>>>
    export type PostApiAddressesCreateOrUpdateMutationBody = BodyType<CCNewAPIDtoAddressDto>
    export type PostApiAddressesCreateOrUpdateMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    /**
 * @summary Creates or updates a service agreement address.
 */
export const usePostApiAddressesCreateOrUpdate = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdate>>, TError,{data: BodyType<CCNewAPIDtoAddressDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAddressesCreateOrUpdate>>,
        TError,
        {data: BodyType<CCNewAPIDtoAddressDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAddressesCreateOrUpdateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will either create new service agreement address records or update existing ones based on the provided collection of address details.
The user ID and application ID are provided via HTTP headers.
The operation is performed asynchronously.
            
Headers:
    UserId: 123
    ApplicationId: 456
            
Sample request:
            
    POST /CreateOrUpdateMultiple
    {
       "addressDtos": {
           "PolicyAddress": {
           "Street": "123 Main St",
           "Town": "London",
           "County": "Greater London",
           "Postcode": "SW1A 1AA",
           },
           "BillingAddress": {
           "Street": "123 Main St",
           "Town": "London",
           "County": "Greater London",
           "Postcode": "SW1A 1AA",
           },
           "CustomerAddress": {
           "Street": "123 Main St",
           "Town": "London",
           "County": "Greater London",
           "Postcode": "SW1A 1AA",
           },
           "ServiceAgreementAddressId": 123
     }
 * @summary Creates or updates multiple service agreement addresses.
 */
export const postApiAddressesCreateOrUpdateMultiple = (
    cCNewAPIDtoAgreementAddressesDto: BodyType<CCNewAPIDtoAgreementAddressesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoAgreementAddressesDto>(
      {url: `/api/Addresses/CreateOrUpdateMultiple`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoAgreementAddressesDto, signal
    },
      options);
    }
  


export const getPostApiAddressesCreateOrUpdateMultipleMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdateMultiple>>, TError,{data: BodyType<CCNewAPIDtoAgreementAddressesDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdateMultiple>>, TError,{data: BodyType<CCNewAPIDtoAgreementAddressesDto>}, TContext> => {

const mutationKey = ['postApiAddressesCreateOrUpdateMultiple'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdateMultiple>>, {data: BodyType<CCNewAPIDtoAgreementAddressesDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAddressesCreateOrUpdateMultiple(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAddressesCreateOrUpdateMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdateMultiple>>>
    export type PostApiAddressesCreateOrUpdateMultipleMutationBody = BodyType<CCNewAPIDtoAgreementAddressesDto>
    export type PostApiAddressesCreateOrUpdateMultipleMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    /**
 * @summary Creates or updates multiple service agreement addresses.
 */
export const usePostApiAddressesCreateOrUpdateMultiple = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAddressesCreateOrUpdateMultiple>>, TError,{data: BodyType<CCNewAPIDtoAgreementAddressesDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAddressesCreateOrUpdateMultiple>>,
        TError,
        {data: BodyType<CCNewAPIDtoAgreementAddressesDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAddressesCreateOrUpdateMultipleMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint creates a new service agreement based on the provided details in the agreement DTO.
It involves an asynchronous operation to interact with the service that handles the creation of new service agreements.
            
Sample request:
            
    POST /CreateNewAgreement
    {
        "agreementDto": {
            "serviceAgreementId": 0,
            "serviceAgreementCustomerId": 42136,
            "serviceAgreementTypeId": 75,
            "userIdEntered": 2566,
            "exclusionDetails": "No exclusions",
            "notes": "Some notes",
            "source": "TEST",
            "serviceAgreementDurationId": 12,
            "serviceAgreementBillingFrequencyId": 12
            },
            "addresses": {
            "policyAddress": {
            "serviceAgreementAddressId": 0,
            "propertyBuildingTypeId": "detached",
            "property": "1234 Elm Street",
            "street": "Elm Street",
            "locality": "Springfield",
            "town": "Metropolis",
            "county": "Gotham",
            "postcode": "12345",
            "bathrooms": 2,
            "bedrooms": 3,
            "externalDoors": 1,
            "gasAppliances": 2,
            "radiators": 4,
            "comments": "Additional notes about the property."
            },
            "usePolicyAddressForAll": true
            }
        }
    }
            
On successful creation, the method returns the details of the newly created service agreement.
 * @summary Create a new agreement
 */
export const postApiAgreementsCreateNewAgreement = (
    cCNewAPIDtoCreateAgreementDto: BodyType<CCNewAPIDtoCreateAgreementDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoAgreementResponseDto>(
      {url: `/api/Agreements/CreateNewAgreement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoCreateAgreementDto, signal
    },
      options);
    }
  


export const getPostApiAgreementsCreateNewAgreementMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsCreateNewAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsCreateNewAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext> => {

const mutationKey = ['postApiAgreementsCreateNewAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgreementsCreateNewAgreement>>, {data: BodyType<CCNewAPIDtoCreateAgreementDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAgreementsCreateNewAgreement(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgreementsCreateNewAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgreementsCreateNewAgreement>>>
    export type PostApiAgreementsCreateNewAgreementMutationBody = BodyType<CCNewAPIDtoCreateAgreementDto>
    export type PostApiAgreementsCreateNewAgreementMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    /**
 * @summary Create a new agreement
 */
export const usePostApiAgreementsCreateNewAgreement = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsCreateNewAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgreementsCreateNewAgreement>>,
        TError,
        {data: BodyType<CCNewAPIDtoCreateAgreementDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAgreementsCreateNewAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiAgreementsAddServiceAgreement = (
    cCNewAPIDtoCreateAgreementDto: BodyType<CCNewAPIDtoCreateAgreementDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoAgreementResponseDto>(
      {url: `/api/Agreements/AddServiceAgreement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoCreateAgreementDto, signal
    },
      options);
    }
  


export const getPostApiAgreementsAddServiceAgreementMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsAddServiceAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsAddServiceAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext> => {

const mutationKey = ['postApiAgreementsAddServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgreementsAddServiceAgreement>>, {data: BodyType<CCNewAPIDtoCreateAgreementDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAgreementsAddServiceAgreement(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgreementsAddServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgreementsAddServiceAgreement>>>
    export type PostApiAgreementsAddServiceAgreementMutationBody = BodyType<CCNewAPIDtoCreateAgreementDto>
    export type PostApiAgreementsAddServiceAgreementMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    export const usePostApiAgreementsAddServiceAgreement = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsAddServiceAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgreementsAddServiceAgreement>>,
        TError,
        {data: BodyType<CCNewAPIDtoCreateAgreementDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAgreementsAddServiceAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiAgreementsUpgradeServiceAgreement = (
    cCNewAPIDtoCreateAgreementDto: BodyType<CCNewAPIDtoCreateAgreementDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoAgreementResponseDto>(
      {url: `/api/Agreements/UpgradeServiceAgreement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoCreateAgreementDto, signal
    },
      options);
    }
  


export const getPostApiAgreementsUpgradeServiceAgreementMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsUpgradeServiceAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsUpgradeServiceAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext> => {

const mutationKey = ['postApiAgreementsUpgradeServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgreementsUpgradeServiceAgreement>>, {data: BodyType<CCNewAPIDtoCreateAgreementDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAgreementsUpgradeServiceAgreement(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgreementsUpgradeServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgreementsUpgradeServiceAgreement>>>
    export type PostApiAgreementsUpgradeServiceAgreementMutationBody = BodyType<CCNewAPIDtoCreateAgreementDto>
    export type PostApiAgreementsUpgradeServiceAgreementMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    export const usePostApiAgreementsUpgradeServiceAgreement = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsUpgradeServiceAgreement>>, TError,{data: BodyType<CCNewAPIDtoCreateAgreementDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgreementsUpgradeServiceAgreement>>,
        TError,
        {data: BodyType<CCNewAPIDtoCreateAgreementDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAgreementsUpgradeServiceAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint generates a preview of the invoices for a new service agreement with the provided details.
It involves an asynchronous operation to interact with the service that handles the generation of the preview invoices.
The preview invoices are returned as a list of service agreement invoice objects.
 * @summary Generates a preview of the invoices for a new service agreement with the provided details.
 */
export const postApiAgreementsPreviewSubscription = (
    careClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIModelsServiceAgreementInvoice[]>(
      {url: `/api/Agreements/PreviewSubscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto, signal
    },
      options);
    }
  


export const getPostApiAgreementsPreviewSubscriptionMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsPreviewSubscription>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsPreviewSubscription>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}, TContext> => {

const mutationKey = ['postApiAgreementsPreviewSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgreementsPreviewSubscription>>, {data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAgreementsPreviewSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgreementsPreviewSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgreementsPreviewSubscription>>>
    export type PostApiAgreementsPreviewSubscriptionMutationBody = BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>
    export type PostApiAgreementsPreviewSubscriptionMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    /**
 * @summary Generates a preview of the invoices for a new service agreement with the provided details.
 */
export const usePostApiAgreementsPreviewSubscription = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsPreviewSubscription>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgreementsPreviewSubscription>>,
        TError,
        {data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAgreementsPreviewSubscriptionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint generates a cost summary of the plan after offers have been applied.
It involves an asynchronous operation to interact with the service that handles the generation of the cost summary.
The cost summary is returned as a plan cost after offers view object.
 * @summary Gets cost of plan after offers
 */
export const postApiAgreementsGetPlanCostAfterOffers = (
    careClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsPlanCostAfterOffersView>(
      {url: `/api/Agreements/GetPlanCostAfterOffers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto, signal
    },
      options);
    }
  


export const getPostApiAgreementsGetPlanCostAfterOffersMutationOptions = <TError = ErrorType<void | MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}, TContext> => {

const mutationKey = ['postApiAgreementsGetPlanCostAfterOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffers>>, {data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiAgreementsGetPlanCostAfterOffers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgreementsGetPlanCostAfterOffersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffers>>>
    export type PostApiAgreementsGetPlanCostAfterOffersMutationBody = BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>
    export type PostApiAgreementsGetPlanCostAfterOffersMutationError = ErrorType<void | MicrosoftAspNetCoreMvcProblemDetails>

    /**
 * @summary Gets cost of plan after offers
 */
export const usePostApiAgreementsGetPlanCostAfterOffers = <TError = ErrorType<void | MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffers>>,
        TError,
        {data: BodyType<CareClubCCMAPIControllersApiV2GeneratePreviewInvoicesDto>},
        TContext
      > => {

      const mutationOptions = getPostApiAgreementsGetPlanCostAfterOffersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets service agreement invoices for a specified contract period
 */
export const getApiAgreementsGetServiceAgreementInvoicesForContractPeriod = (
    params?: GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIModelsServiceAgreementInvoice[]>(
      {url: `/api/Agreements/GetServiceAgreementInvoicesForContractPeriod`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiAgreementsGetServiceAgreementInvoicesForContractPeriodQueryKey = (params?: GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodParams,) => {
    return [`/api/Agreements/GetServiceAgreementInvoicesForContractPeriod`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAgreementsGetServiceAgreementInvoicesForContractPeriodQueryOptions = <TData = Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>>(params?: GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAgreementsGetServiceAgreementInvoicesForContractPeriodQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>> = ({ signal }) => getApiAgreementsGetServiceAgreementInvoicesForContractPeriod(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>>
export type GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>


/**
 * @summary Gets service agreement invoices for a specified contract period
 */

export function useGetApiAgreementsGetServiceAgreementInvoicesForContractPeriod<TData = Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>>(
 params?: GetApiAgreementsGetServiceAgreementInvoicesForContractPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAgreementsGetServiceAgreementInvoicesForContractPeriod>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAgreementsGetServiceAgreementInvoicesForContractPeriodQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint generates a cost summary of the plan after offers have been applied for all combinations.
It involves an asynchronous operation to interact with the service that handles the generation of the cost summary.
The cost summary is returned as a list of plan cost after offers view objects.
 * @summary Gets cost of plan after offers for all combinations
 */
export const postApiAgreementsGetPlanCostAfterOffersForAllCombinations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpCallServiceAgreementsGetBasicPlanCostForAllCombinationsResult[]>(
      {url: `/api/Agreements/GetPlanCostAfterOffersForAllCombinations`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiAgreementsGetPlanCostAfterOffersForAllCombinationsMutationOptions = <TError = ErrorType<void | MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffersForAllCombinations>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffersForAllCombinations>>, TError,void, TContext> => {

const mutationKey = ['postApiAgreementsGetPlanCostAfterOffersForAllCombinations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffersForAllCombinations>>, void> = () => {
          

          return  postApiAgreementsGetPlanCostAfterOffersForAllCombinations(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAgreementsGetPlanCostAfterOffersForAllCombinationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffersForAllCombinations>>>
    
    export type PostApiAgreementsGetPlanCostAfterOffersForAllCombinationsMutationError = ErrorType<void | MicrosoftAspNetCoreMvcProblemDetails>

    /**
 * @summary Gets cost of plan after offers for all combinations
 */
export const usePostApiAgreementsGetPlanCostAfterOffersForAllCombinations = <TError = ErrorType<void | MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffersForAllCombinations>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAgreementsGetPlanCostAfterOffersForAllCombinations>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiAgreementsGetPlanCostAfterOffersForAllCombinationsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will either create a new service agreement customer record or update an existing one based on the provided information.
It takes a customer DTO, the service agreement ID, and the user ID and application ID from HTTP headers as parameters.
The operation is performed asynchronously.
            
Headers:
    UserId: 123
    ApplicationId: 456
            
Sample request:
            
    POST /CreateOrUpdate
    {
       "customerDto": {
           "Name": "John Doe",
           "Email": "johndoe@example.com",
           "Phone": "01234567890",
           "Mobile": "01234567890",
           "Email": "johndoe@example"
       },
       "serviceAgreementId": 789
    }
 * @summary Creates a new service agreement customer or updates an existing one.
 */
export const postApiCustomersCreateOrUpdate = (
    cCNewAPIDtoCustomerDto: BodyType<CCNewAPIDtoCustomerDto>,
    params?: PostApiCustomersCreateOrUpdateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoCustomerDto>(
      {url: `/api/Customers/CreateOrUpdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoCustomerDto,
        params, signal
    },
      options);
    }
  


export const getPostApiCustomersCreateOrUpdateMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersCreateOrUpdate>>, TError,{data: BodyType<CCNewAPIDtoCustomerDto>;params?: PostApiCustomersCreateOrUpdateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersCreateOrUpdate>>, TError,{data: BodyType<CCNewAPIDtoCustomerDto>;params?: PostApiCustomersCreateOrUpdateParams}, TContext> => {

const mutationKey = ['postApiCustomersCreateOrUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCustomersCreateOrUpdate>>, {data: BodyType<CCNewAPIDtoCustomerDto>;params?: PostApiCustomersCreateOrUpdateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCustomersCreateOrUpdate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCustomersCreateOrUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCustomersCreateOrUpdate>>>
    export type PostApiCustomersCreateOrUpdateMutationBody = BodyType<CCNewAPIDtoCustomerDto>
    export type PostApiCustomersCreateOrUpdateMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    /**
 * @summary Creates a new service agreement customer or updates an existing one.
 */
export const usePostApiCustomersCreateOrUpdate = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersCreateOrUpdate>>, TError,{data: BodyType<CCNewAPIDtoCustomerDto>;params?: PostApiCustomersCreateOrUpdateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCustomersCreateOrUpdate>>,
        TError,
        {data: BodyType<CCNewAPIDtoCustomerDto>;params?: PostApiCustomersCreateOrUpdateParams},
        TContext
      > => {

      const mutationOptions = getPostApiCustomersCreateOrUpdateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will create a new service agreement customer record in the database and GoCardless.
It takes a customer DTO and a customer request DTO as parameters.
The operation is performed asynchronously.
            
Sample request:
    POST /CreateCustomerInGoCardlessAndDatabase
    {
    "customerDto": {
    "Name": "John Doe",
    "Email": "johndoe@example",
    "Phone": "01234567890",
    "Mobile": "01234567890",
    "Email": "johndoe@example"
    },
    "Property": "1",
    "Street": "Test Street",
    "City": "Test City",
    "Postcode": "TE1 1ST",
    "County": "Test County"
    }
    }
 * @summary Creates a new service agreement customer in database and GoCardless.
 */
export const postApiCustomersCreateCustomerInGoCardlessAndDatabase = (
    careClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto: BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedResponseDto>(
      {url: `/api/Customers/CreateCustomerInGoCardlessAndDatabase`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto, signal
    },
      options);
    }
  


export const getPostApiCustomersCreateCustomerInGoCardlessAndDatabaseMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersCreateCustomerInGoCardlessAndDatabase>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersCreateCustomerInGoCardlessAndDatabase>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>}, TContext> => {

const mutationKey = ['postApiCustomersCreateCustomerInGoCardlessAndDatabase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCustomersCreateCustomerInGoCardlessAndDatabase>>, {data: BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCustomersCreateCustomerInGoCardlessAndDatabase(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCustomersCreateCustomerInGoCardlessAndDatabaseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCustomersCreateCustomerInGoCardlessAndDatabase>>>
    export type PostApiCustomersCreateCustomerInGoCardlessAndDatabaseMutationBody = BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>
    export type PostApiCustomersCreateCustomerInGoCardlessAndDatabaseMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>

    /**
 * @summary Creates a new service agreement customer in database and GoCardless.
 */
export const usePostApiCustomersCreateCustomerInGoCardlessAndDatabase = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersCreateCustomerInGoCardlessAndDatabase>>, TError,{data: BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCustomersCreateCustomerInGoCardlessAndDatabase>>,
        TError,
        {data: BodyType<CareClubCCMAPIControllersApiV2CustomersControllerCreateCustomerExtendedDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCustomersCreateCustomerInGoCardlessAndDatabaseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sends a welcome pack to the user based on the provided service agreement id, send by post flag and user id.
 * @summary Sends a welcome pack to the user.
 */
export const postApiCustomersSendWelcomePack = (
    params?: PostApiCustomersSendWelcomePackParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcIActionResult>(
      {url: `/api/Customers/SendWelcomePack`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCustomersSendWelcomePackMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersSendWelcomePack>>, TError,{params?: PostApiCustomersSendWelcomePackParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersSendWelcomePack>>, TError,{params?: PostApiCustomersSendWelcomePackParams}, TContext> => {

const mutationKey = ['postApiCustomersSendWelcomePack'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCustomersSendWelcomePack>>, {params?: PostApiCustomersSendWelcomePackParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCustomersSendWelcomePack(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCustomersSendWelcomePackMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCustomersSendWelcomePack>>>
    
    export type PostApiCustomersSendWelcomePackMutationError = ErrorType<string>

    /**
 * @summary Sends a welcome pack to the user.
 */
export const usePostApiCustomersSendWelcomePack = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCustomersSendWelcomePack>>, TError,{params?: PostApiCustomersSendWelcomePackParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCustomersSendWelcomePack>>,
        TError,
        {params?: PostApiCustomersSendWelcomePackParams},
        TContext
      > => {

      const mutationOptions = getPostApiCustomersSendWelcomePackMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint sends an email.
 * @summary Sends an email
 */
export const postApiEmailSendEmail = (
    rightioEmailSenderModelsEmailNoAttachmentsDto: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/Email/SendEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioEmailSenderModelsEmailNoAttachmentsDto, signal
    },
      options);
    }
  


export const getPostApiEmailSendEmailMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmailSendEmail>>, TError,{data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmailSendEmail>>, TError,{data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}, TContext> => {

const mutationKey = ['postApiEmailSendEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmailSendEmail>>, {data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiEmailSendEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmailSendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmailSendEmail>>>
    export type PostApiEmailSendEmailMutationBody = BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>
    export type PostApiEmailSendEmailMutationError = ErrorType<string>

    /**
 * @summary Sends an email
 */
export const usePostApiEmailSendEmail = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmailSendEmail>>, TError,{data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmailSendEmail>>,
        TError,
        {data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>},
        TContext
      > => {

      const mutationOptions = getPostApiEmailSendEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint retrieves the fee associated with a specific service agreement, including any adjustments based on the given parameters.
The parameters include the type, duration, billing frequency, and excess of the service agreement.
An optional 'website' parameter can be provided to specify the context of the request.
            
Sample request:
            
    POST /GetServiceAgreementFeeWithAdjustments
    {
        "serviceAgreementTypeId": 1,
        "serviceAgreementDurationId": 2,
        "serviceAgreementBillingFrequencyId": 3,
        "serviceAgreementExcessId": 4,
        "website": true
    }
 * @summary Retrieves the fee details for a service agreement with adjustments.
 */
export const postApiFeesGetServiceAgreementFeeWithAdjustments = (
    params?: PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoFeeWithAdjustmentDto>(
      {url: `/api/Fees/GetServiceAgreementFeeWithAdjustments`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiFeesGetServiceAgreementFeeWithAdjustmentsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiFeesGetServiceAgreementFeeWithAdjustments>>, TError,{params?: PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiFeesGetServiceAgreementFeeWithAdjustments>>, TError,{params?: PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams}, TContext> => {

const mutationKey = ['postApiFeesGetServiceAgreementFeeWithAdjustments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiFeesGetServiceAgreementFeeWithAdjustments>>, {params?: PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiFeesGetServiceAgreementFeeWithAdjustments(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiFeesGetServiceAgreementFeeWithAdjustmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiFeesGetServiceAgreementFeeWithAdjustments>>>
    
    export type PostApiFeesGetServiceAgreementFeeWithAdjustmentsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    /**
 * @summary Retrieves the fee details for a service agreement with adjustments.
 */
export const usePostApiFeesGetServiceAgreementFeeWithAdjustments = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiFeesGetServiceAgreementFeeWithAdjustments>>, TError,{params?: PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiFeesGetServiceAgreementFeeWithAdjustments>>,
        TError,
        {params?: PostApiFeesGetServiceAgreementFeeWithAdjustmentsParams},
        TContext
      > => {

      const mutationOptions = getPostApiFeesGetServiceAgreementFeeWithAdjustmentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const getApiOffers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIModelsServiceAgreementOffer[]>(
      {url: `/api/Offers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiOffersQueryKey = () => {
    return [`/api/Offers`] as const;
    }

    
export const getGetApiOffersQueryOptions = <TData = Awaited<ReturnType<typeof getApiOffers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiOffers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOffersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOffers>>> = ({ signal }) => getApiOffers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOffers>>>
export type GetApiOffersQueryError = ErrorType<unknown>



export function useGetApiOffers<TData = Awaited<ReturnType<typeof getApiOffers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiOffers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiOffersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiOffersId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIModelsServiceAgreementOffer>(
      {url: `/api/Offers/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiOffersIdQueryKey = (id: number,) => {
    return [`/api/Offers/${id}`] as const;
    }

    
export const getGetApiOffersIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiOffersId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiOffersId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOffersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOffersId>>> = ({ signal }) => getApiOffersId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiOffersId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiOffersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOffersId>>>
export type GetApiOffersIdQueryError = ErrorType<unknown>



export function useGetApiOffersId<TData = Awaited<ReturnType<typeof getApiOffersId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiOffersId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiOffersIdQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint retrieves a list of offers available for a given set of criteria including agreement ID, agreement type, billing frequency, duration, and other parameters.
Application ID and user ID are provided via HTTP headers.
Additional parameters include details about the agreement, billing, and campaign codes.
            
System offers can be applied only by system during the agreement creation process.
So please use this flag with caution.
            
Sample request:
            
    POST /GetAvailableOffersWithDiscounts
    Headers:
        ApplicationId: 1
        UserId: 1
    Body:
    {
        "agreementId": 0,
        "agreementTypeId": 74,
        "billingFrequencyInMonths": 12,
        "durationInMonths": 12,
        "allocationContractPeriod": 1,
        "campaignCodeId": 0,
        "excessId": 0,
        "includeSystemOffers": true
    }
 * @summary Retrieves a list of available offers with applicable discounts.
 */
export const postApiOffersGetAvailableOffersWithDiscounts = (
    params?: PostApiOffersGetAvailableOffersWithDiscountsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoServiceAgreementOfferDto[]>(
      {url: `/api/Offers/GetAvailableOffersWithDiscounts`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiOffersGetAvailableOffersWithDiscountsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOffersGetAvailableOffersWithDiscounts>>, TError,{params?: PostApiOffersGetAvailableOffersWithDiscountsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiOffersGetAvailableOffersWithDiscounts>>, TError,{params?: PostApiOffersGetAvailableOffersWithDiscountsParams}, TContext> => {

const mutationKey = ['postApiOffersGetAvailableOffersWithDiscounts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOffersGetAvailableOffersWithDiscounts>>, {params?: PostApiOffersGetAvailableOffersWithDiscountsParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiOffersGetAvailableOffersWithDiscounts(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiOffersGetAvailableOffersWithDiscountsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOffersGetAvailableOffersWithDiscounts>>>
    
    export type PostApiOffersGetAvailableOffersWithDiscountsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    /**
 * @summary Retrieves a list of available offers with applicable discounts.
 */
export const usePostApiOffersGetAvailableOffersWithDiscounts = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOffersGetAvailableOffersWithDiscounts>>, TError,{params?: PostApiOffersGetAvailableOffersWithDiscountsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiOffersGetAvailableOffersWithDiscounts>>,
        TError,
        {params?: PostApiOffersGetAvailableOffersWithDiscountsParams},
        TContext
      > => {

      const mutationOptions = getPostApiOffersGetAvailableOffersWithDiscountsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const postApiPaymentDetailsCreatePaymentDetails = (
    cCNewAPIDtoPaymentDetailsDto: BodyType<CCNewAPIDtoPaymentDetailsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CCNewAPIDtoPaymentDetailsDto>(
      {url: `/api/PaymentDetails/CreatePaymentDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cCNewAPIDtoPaymentDetailsDto, signal
    },
      options);
    }
  


export const getPostApiPaymentDetailsCreatePaymentDetailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPaymentDetailsCreatePaymentDetails>>, TError,{data: BodyType<CCNewAPIDtoPaymentDetailsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPaymentDetailsCreatePaymentDetails>>, TError,{data: BodyType<CCNewAPIDtoPaymentDetailsDto>}, TContext> => {

const mutationKey = ['postApiPaymentDetailsCreatePaymentDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPaymentDetailsCreatePaymentDetails>>, {data: BodyType<CCNewAPIDtoPaymentDetailsDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiPaymentDetailsCreatePaymentDetails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiPaymentDetailsCreatePaymentDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPaymentDetailsCreatePaymentDetails>>>
    export type PostApiPaymentDetailsCreatePaymentDetailsMutationBody = BodyType<CCNewAPIDtoPaymentDetailsDto>
    export type PostApiPaymentDetailsCreatePaymentDetailsMutationError = ErrorType<unknown>

    export const usePostApiPaymentDetailsCreatePaymentDetails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPaymentDetailsCreatePaymentDetails>>, TError,{data: BodyType<CCNewAPIDtoPaymentDetailsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiPaymentDetailsCreatePaymentDetails>>,
        TError,
        {data: BodyType<CCNewAPIDtoPaymentDetailsDto>},
        TContext
      > => {

      const mutationOptions = getPostApiPaymentDetailsCreatePaymentDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    